<template>
  <div>
    <el-row class="chart-list">
      <span @click="ShowTableDetail">
        チャートパネル
        <i :class="$root.historyChatShowFlg ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </span>
    </el-row>
    <el-row v-show="$root.historyChatShowFlg">
      <div>
        <draggable
          v-model="$root.usedChartList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
          @end="draggerEnd"
        >
          <component
            v-for="(chart, index) in $root.usedChartList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
        <el-dialog
          :title="$root.currentPopUpTitle"
          :visible.sync="$root.popUpDisplay"
          :append-to-body="true"
          class="historyDailog"
        >
          <hr />
          <echarts
            :auto-resize="true"
            :option="$root.currentChartData"
            style="height: 75vh"
          />
        </el-dialog>
      </div>
    </el-row>
    
    <!-- Chatbot FAB Button -->
    <div class="chatbot-fab" id="chatbot" v-if="$root.activeName === 'history'" @click="toggleChatbot">
      <img src="../assets/img/chatbot_icon.png" alt="Chatbot" />
    </div>
    <!-- Chatbot iframe -->
    <iframe 
      v-if="iframeLoaded && $root.activeName === 'history'" 
      id="chatIframe" 
      :src="iframeSrc" 
      allow="microphone; camera; geolocation"
      title="Query Agent Chat" 
      class="chatbot-iframe" 
      allowfullscreen
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups">
    </iframe>
  </div>
</template>

<script>
import api from "@/api";
import draggable from "vuedraggable";
export default {
  name: "HistoryMain",
  data() {
    return {
      iframeLoaded: false, // iframeが読み込まれたかどうか
      iframeSrc: "", // iframeのsrc
      chatbotOpen: false, // chatbotが開いているかどうか
    };
  },
  components: {
    draggable,
  },
  methods: {
    toggleChatbot() {
      this.chatbotOpen = !this.chatbotOpen;
      
      if (this.chatbotOpen) {
        // 初回クリック時のみiframeを読み込む
        if (!this.iframeLoaded) {
          let iframeUrl = `${process.env.VUE_APP_QUERY_AGENT_URL}?embed=true&mode=chat&client=UC3`;
          // let iframeUrl = "https://queryagent.chubcluster-jp-tok-1-bx2-48818347541c3c194b779ca28a67ee15-0000.jp-tok.containers.appdomain.cloud?embed=true&mode=chat";
          
          this.iframeSrc = iframeUrl;
          this.iframeLoaded = true;
        }
        
        // iframeが読み込まれるのを待ってからactiveクラスを追加
        this.$nextTick(() => {
          const iframe = document.getElementById('chatIframe');
          if (iframe) {
            iframe.classList.add('active');
          }
        });
      } else {
        // chatbotを閉じる
        const iframe = document.getElementById('chatIframe');
        if (iframe) {
          iframe.classList.remove('active');
        }
      }
    },
    draggerEnd(evt) {
      this.drag = true;
      let fromIndex = 0;
      let toIndex = 0;
      let displayName = '';
      if (evt.newIndex > evt.oldIndex) {
        fromIndex = this.$root.usedChartList[evt.newIndex].index;
        toIndex = this.$root.usedChartList[evt.newIndex - 1].index;
        displayName = this.$root.usedChartList[evt.newIndex].displayName;
      } else {
        fromIndex = this.$root.usedChartList[evt.newIndex].index;
        toIndex = this.$root.usedChartList[evt.newIndex + 1].index;
        displayName = this.$root.usedChartList[evt.newIndex].displayName;
      }
      console.log('fromIndex', fromIndex)
      console.log('toIndex', toIndex)
      let data = {
        user_id: this.$root.user.user_id,
        fromIndex: fromIndex,
        toIndex: toIndex,
        displayName: displayName
      };

      api.saveUserEcharIndex(data).then(
        () => {
        },
        (err) => {
          console.log(err);
        }
      );
    },
    ShowTableDetail() {
      if (this.$root.editMode == false) {
        if (this.$root.historyChatShowFlg == true) {
          this.$root.historyChatShowFlg = false;
          if (this.$root.allBarShowFlg == true) {
            this.$root.historyChatHeight = '500px';
          } else if (this.$root.allBarShowFlg == false) {
            this.$root.historyChatHeight = '600px';
          }
          
        } else if (this.$root.historyChatShowFlg == false){
          this.$root.historyChatShowFlg = true;
          this.$root.historyChatHeight = '100%';
        }
      } else if (this.$root.editMode == true) {
        if (this.$root.historyChatShowFlg == true) {
          this.$root.historyChatShowFlg = false;
          this.$root.historyChatHeight = '635px';
        } else if (this.$root.historyChatShowFlg == false){
          this.$root.historyChatShowFlg = true;
          this.$root.historyChatHeight = '100%';
        }
      }
    },
    showHideCharts(){
      this.$root.historyChatShowFlg = !this.$root.historyChatShowFlg
    }
  },
};
</script>
<style>
.chart-list {
  padding: 10px 0;
  /* margin-bottom: 20px; */
  cursor: pointer;
  text-align: center;
}
.el-button--small.is-circle {
  padding: 3px;
}
.el-input__inner {
  height: 20px !important;
  line-height: 20px !important;
}
.el-input__icon {
  line-height: 14px !important;
}
.el-date-editor .el-range-separator {
  line-height: 14px !important;
}
.sub-view {
  padding: 20px;
  height: 180px;
  margin: 5px;
  background-color: white;
  min-height: 380px;
}

.chart-view {
  height: 100% !important;
  min-height: 350px;
  max-height: 46vh !important;
}

.chart-view2 {
  height: 100% !important;
  min-height: 270px;
  max-height: 42vh !important;
}

.echarts {
  width: inherit !important;
}

.sub-view .sub-title {
  background-color: lightgrey;
  padding: 5px;
  margin-bottom: 0;
  font-weight: bold;
}

.sub-view .el-icon-close,
.sub-view .el-icon-zoom-in {
  float: right;
}

.el-icon-close:hover,
.el-icon-zoom-in:hover {
  cursor: pointer;
}

.el-alert {
  margin-top: 5px;
}

.el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__title {
  font-weight: bold;
}

.el-dialog {
  margin-top: 10vh !important;
  /* width: 70%;
  min-height: 80%; */
}

/* Chatbot FAB Button */
.chatbot-fab {
  position: fixed;
  right: 32px;
  bottom: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  transition: box-shadow 0.2s;
}

.chatbot-fab:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.chatbot-fab img {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: transparent;
}

/* Chatbot iframe */
.chatbot-iframe {
  position: fixed;
  right: 40px;
  bottom: 90px;
  width: 375px;
  height: 580px;
  border: none;
  border-radius: 18px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.18);
  z-index: 101;
  display: none;
  background: #fff;
  overflow: hidden;
}

.chatbot-iframe.active {
  display: block;
}

/* Responsive Design for Mobile */
@media (max-width: 500px) {
  .chatbot-iframe {
    width: 98vw;
    right: 1vw;
    height: 60vh;
    bottom: 100px;
  }

  .chatbot-fab {
    right: 1vw;
    bottom: 20px;
  }
}

</style>
